module.exports = __webpack_public_path__ + "img/icon-minus.87c400c6.svg";